var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"review-panel"}},[_c('settings'),_c('div',{staticClass:"the-panel"},[(_vm.what)?_c(_vm.what,{tag:"component"}):_c('div',{staticClass:"instructions"},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":"arrow-left"}}),_vm._v(" Click a file in the sidebar to view it. ")],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }